import Vue from "vue";
import VueRouter from "vue-router";
import VueYandexMetrika from "vue-yandex-metrika";
// eslint-disable-next-line no-unused-vars
import store from "../store";
import HomeView from "../views/HomeView.vue";
import PatientView from "@/views/PatientView";

import AdminProductsView from "@/views/admin/AdminProductsView.vue";
import AdminPatientsView from "@/views/admin/AdminPatientsView.vue";
import AdminCompaniesView from "@/views/admin/AdminCompaniesView.vue";
import AdminManagersView from "@/views/admin/AdminManagersView.vue";
import AdminPreferenceView from "@/views/admin/AdminPreferenceView.vue";
import AdminUsersView from "@/views/admin/AdminUsersView.vue";
import AdminProductCategoriesView from "@/views/admin/AdminProductCategoriesView.vue";
import AdminNewsView from "@/views/admin/AdminNewsView.vue";
import AdminMaterialsView from "@/views/admin/AdminMaterialsView.vue";

import CompanyProductsView from "@/views/company/CompanyProductsView.vue";
import CompanyPatientsView from "@/views/company/CompanyPatientsView.vue";
import CompanyUsersView from "@/views/company/CompanyUsersView.vue";
import CompanyNewsView from "@/views/company/CompanyNewsView.vue";
import CompanyParentsView from "@/views/company/CompanyParentsView.vue";
import CompanyRecommendationView from "@/views/company/CompanyRecommendationView.vue";
import VideoAndMaterialsView from "@/views/company/VideoAndMaterialsView.vue";

import NewUserView from "@/views/NewUserView";
import ReportsView from "@/views/ReportsView.vue";
import B2CView from "@/views/B2CView.vue";

import ForbiddenRoute from "./errorRoutes/ForbiddenRoute";
import NotFoundRoute from "./errorRoutes/NotFoundRoute";

import { ALL_ROLES } from "@/utils/constants";
import ManagerProductsView from "@/views/manager/ManagerProductsView.vue";
import ManagerProductCategoriesView from "@/views/manager/ManagerProductCategoriesView.vue";
import ManagerCompaniesView from "@/views/manager/ManagerCompaniesView.vue";
import ManagerUsersView from "@/views/manager/ManagerUsersView.vue";
import ManagerPatientsView from "@/views/manager/ManagerPatientsView.vue";
import ManagerNewsView from "@/views/manager/ManagerNewsView.vue";

import PatientSessionView from "@/views/patient/PatientSessionView.vue";

import DeveloperView from "@/views/DeveloperView";
import SessionByUrlView from "@/views/SessionByUrlView";
import AdminFeedbackView from "@/views/admin/AdminFeedbackView.vue";
import AdminVkReviewsView from "@/views/admin/AdminVkReviewsView.vue";
import AdminTestimonialsView from "@/views/admin/AdminTestimonialsView.vue";
import AdminSiteNewsView from "@/views/admin/AdminSiteNewsView.vue";
import AdminDashboardView from "@/views/admin/AdminDashboardView.vue";
import BalanceTopupSuccessView from "@/views/BalanceTopupSuccessView.vue";
import PrivacyView from "@/views/PrivacyView.vue";
import AgreementView from "@/views/AgreementView.vue";

Vue.use(VueRouter);

const routes = [
  /**
   * Routes for all users
   */
  {
    path: "/privacy",
    name: "privacy",
    meta: { requiredRoles: ALL_ROLES },
    component: PrivacyView,
  },
  {
    path: "/agreement",
    name: "agreement",
    meta: { requiredRoles: ALL_ROLES },
    component: AgreementView,
  },
  {
    path: "/",
    name: "home",
    meta: {
      requiredRoles: ALL_ROLES,
    },
    component: HomeView,
  },
  {
    path: "/faq",
    name: "faq",
    meta: { requiredRoles: ALL_ROLES },
  },
  {
    path: "/noaccess",
    component: ForbiddenRoute,
    meta: { requiredRoles: ALL_ROLES },
  },
  {
    path: "*",
    component: NotFoundRoute,
    meta: { requiredRoles: ALL_ROLES },
  },
  /**
   * Admin routes
   */
  {
    path: "/admin",
    name: "admin",
    meta: { requiredRoles: ["admin"] },
  },
  {
    path: "/admin/products",
    name: "admin-products",
    meta: { requiredRoles: ["admin"] },
    component: AdminProductsView,
  },
  {
    path: "/admin/product-categories",
    name: "admin-product-categories",
    meta: { requiredRoles: ["admin"] },
    component: AdminProductCategoriesView,
  },
  {
    path: "/admin/managers",
    name: "admin-managers",
    meta: { requiredRoles: ["admin"] },
    component: AdminManagersView,
  },
  {
    path: "/admin/preference",
    name: "admin-preference",
    meta: { requiredRoles: ["admin"] },
    component: AdminPreferenceView,
  },
  {
    path: "/admin/companies",
    name: "admin-companies",
    meta: { requiredRoles: ["admin"] },
    component: AdminCompaniesView,
  },
  {
    path: "/admin/users",
    name: "admin-users",
    meta: { requiredRoles: ["admin"] },
    component: AdminUsersView,
  },
  {
    path: "/admin/users/new",
    name: "admin-new-user",
    meta: { requiredRoles: ["admin"] },
    component: NewUserView,
    props: { redirectBackTo: "admin-users" },
  },
  {
    path: "/admin/patients/:patient_id",
    name: "admin-patient",
    meta: { requiredRoles: ["admin"] },
    props: true,
    component: PatientView,
  },
  {
    path: "/admin/patients",
    name: "admin-patients",
    meta: { requiredRoles: ["admin"] },
    component: AdminPatientsView,
  },
  {
    path: "/admin/reports",
    name: "admin-reports",
    meta: { requiredRoles: ["admin"] },
    component: ReportsView,
  },
  {
    path: "/admin/news",
    name: "admin-news",
    meta: { requiredRoles: ["admin", "manager", "company-user"] },
    component: AdminNewsView,
  },
  {
    path: "/admin/b2c",
    name: "admin-bc2",
    meta: { requiredRoles: ["admin"] },
    component: B2CView,
  },
  {
    path: "/admin/feedback",
    name: "admin-feedback",
    meta: { requiredRoles: ["admin", "manager"] },
    component: AdminFeedbackView,
  },
  {
    path: "/admin/vk-reviews",
    name: "admin-vk-reviews",
    meta: { requiredRoles: ["admin", "manager"] },
    component: AdminVkReviewsView,
  },
  {
    path: "/admin/testimonials",
    name: "admin-testimonials",
    meta: { requiredRoles: ["admin", "manager"] },
    component: AdminTestimonialsView,
  },
  {
    path: "/admin/site-news",
    name: "admin-site-news",
    meta: { requiredRoles: ["admin", "blogger"] },
    component: AdminSiteNewsView,
  },
  {
    path: "/admin/dashboards",
    name: "admin-dashboards",
    meta: { requiredRoles: ["admin"] },
    component: AdminDashboardView,
  },
  {
    path: "/admin/materials",
    name: "admin-materials",
    meta: { requiredRoles: ["admin"] },
    component: AdminMaterialsView,
  },
  {
    path: "/admin/parents",
    name: "admin-parents",
    meta: { requiredRoles: ["admin"] },
    component: CompanyParentsView,
  },
  {
    path: "/admin/parents/adults",
    name: "admin-parents-adults",
    meta: { requiredRoles: ["admin"] },
    component: CompanyParentsView,
  },
  {
    path: "/admin/parents/children",
    name: "admin-parents-children",
    meta: { requiredRoles: ["admin"] },
    component: CompanyParentsView,
  },
  {
    path: "/admin/parents/adults/recommendation",
    name: "admin-parents-adults-recommendation",
    meta: { requiredRoles: ["admin"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/admin/parents/adults/video-and-materials",
    name: "admin-parents-adults-video-and-materials",
    meta: { requiredRoles: ["admin"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/admin/parents/children/recommendation",
    name: "admin-parents-children-recommendation",
    meta: { requiredRoles: ["admin"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/admin/parents/children/video-and-materials",
    name: "admin-parents-children-video-and-materials",
    meta: { requiredRoles: ["admin"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/admin/parents/recommendation",
    name: "admin-parents-recommendation",
    meta: { requiredRoles: ["admin"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/admin/video-and-materials",
    name: "admin-video-and-materials",
    meta: { requiredRoles: ["admin"] },
    component: VideoAndMaterialsView,
  },
  /**
   * Company user and company owner routes
   */
  {
    path: "/my/products",
    name: "company-products",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: CompanyProductsView,
  },
  {
    path: "/my/users",
    name: "company-users",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: CompanyUsersView,
  },
  {
    path: "/my/users/new",
    name: "company-new-user",
    meta: { requiredRoles: ["company-owner"] },
    component: NewUserView,
    props: { redirectBackTo: "company-users" },
  },
  {
    path: "/my/patients/:patient_id",
    name: "company-patient",
    meta: {
      requiredRoles: ["company-user", "company-owner"],
    },
    props: true,
    component: PatientView,
  },
  {
    path: "/my/patients",
    name: "company-patients",
    meta: {
      requiredRoles: ["company-user", "company-owner"],
    },
    component: CompanyPatientsView,
  },
  {
    path: "/my",
    name: "customer",
    meta: { requiredRoles: ["company-owner", "company-user"] },
  },
  {
    path: "/my/reports",
    name: "company-reports",
    meta: { requiredRoles: ["company-owner"] },
    component: ReportsView,
  },
  {
    path: "/my/news",
    name: "company-news",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: CompanyNewsView,
  },
  {
    path: "/my/parents",
    name: "company-parents",
    meta: { requiredRoles: ["company-user", "company-owner", "manager"] },
    component: CompanyParentsView,
  },
  {
    path: "/my/parents/adults",
    name: "company-parents-adults",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: CompanyParentsView,
  },
  {
    path: "/my/parents/children",
    name: "company-parents-children",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: CompanyParentsView,
  },
  {
    path: "/my/parents/adults/recommendation",
    name: "company-parents-adults-recommendation",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/my/parents/adults/video-and-materials",
    name: "company-parents-adults-video-and-materials",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/my/parents/children/recommendation",
    name: "company-parents-children-recommendation",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/my/parents/children/video-and-materials",
    name: "company-parents-children-video-and-materials",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/my/parents/recommendation",
    name: "company-parents-recommendation",
    meta: {
      requiredRoles: ["company-user", "company-owner"],
    },
    component: CompanyRecommendationView,
  },
  {
    path: "/my/video-and-materials",
    name: "company-video-and-materials",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/balance-topup-success",
    name: "balance-topup-success",
    meta: { requiredRoles: ["company-user", "company-owner"] },
    component: BalanceTopupSuccessView,
  },
  /**
   * Manager routes
   */
  {
    path: "/manager",
    name: "manager",
    meta: { requiredRoles: ["manager"] },
  },
  {
    path: "/manager/products",
    name: "manager-products",
    meta: { requiredRoles: ["manager"] },
    component: ManagerProductsView,
  },
  {
    path: "/manager/product-categories",
    name: "manager-product-categories",
    meta: { requiredRoles: ["manager"] },
    component: ManagerProductCategoriesView,
  },
  {
    path: "/manager/companies",
    name: "manager-companies",
    meta: { requiredRoles: ["manager"] },
    component: ManagerCompaniesView,
  },
  {
    path: "/manager/users",
    name: "manager-users",
    meta: { requiredRoles: ["manager"] },
    component: ManagerUsersView,
  },
  {
    path: "/manager/patients/:patient_id",
    name: "manager-patient",
    meta: { requiredRoles: ["manager"] },
    props: true,
    component: PatientView,
  },
  {
    path: "/manager/patients",
    name: "manager-patients",
    meta: { requiredRoles: ["manager"] },
    component: ManagerPatientsView,
  },
  {
    path: "/manager/news",
    name: "manager-news",
    meta: { requiredRoles: ["manager"] },
    component: ManagerNewsView,
  },
  {
    path: "/manager/parents",
    name: "manager-parents",
    meta: { requiredRoles: ["manager"] },
    component: CompanyParentsView,
  },
  {
    path: "/manager/parents/adults",
    name: "manager-parents-adults",
    meta: { requiredRoles: ["manager"] },
    component: CompanyParentsView,
  },
  {
    path: "/manager/parents/children",
    name: "manager-parents-children",
    meta: { requiredRoles: ["manager"] },
    component: CompanyParentsView,
  },
  {
    path: "/manager/parents/adults/recommendation",
    name: "manager-parents-adults-recommendation",
    meta: { requiredRoles: ["manager"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/manager/parents/adults/video-and-materials",
    name: "manager-parents-adults-video-and-materials",
    meta: { requiredRoles: ["manager"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/manager/parents/children/recommendation",
    name: "manager-parents-children-recommendation",
    meta: { requiredRoles: ["manager"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/manager/parents/children/video-and-materials",
    name: "manager-parents-children-video-and-materials",
    meta: { requiredRoles: ["manager"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/manager/parents/recommendation",
    name: "manager-parents-recommendation",
    meta: { requiredRoles: ["manager"] },
    component: CompanyRecommendationView,
  },
  {
    path: "/manager/video-and-materials",
    name: "manager-video-and-materials",
    meta: { requiredRoles: ["manager"] },
    component: VideoAndMaterialsView,
  },
  {
    path: "/manager/reports",
    name: "manager-reports",
    meta: { requiredRoles: ["manager"] },
    component: ReportsView,
  },
  {
    path: "/manager/b2c",
    name: "manager-b2c",
    meta: { requiredRoles: ["manager"] },
    component: B2CView,
  },
  /**
   * Patient routes
   */
  {
    path: "/patient/sessions",
    name: "patient-sessions",
    meta: { requiredRoles: ["patient"] },
    component: PatientSessionView,
  },
  /**
   * For debug
   */
  {
    path: "/developer",
    name: "developer",
    meta: { requiredRoles: ["admin"] },
    component: DeveloperView,
  },

  {
    path: "/session-by-url/:visit_uuid",
    name: "session-by-url",
    meta: { public: true },
    props: true,
    component: SessionByUrlView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

Vue.use(VueYandexMetrika, {
  id: process.env.VUE_APP_YANDEX_METRIKA_ID || 1,
  router: router,
  env: process.env.VUE_APP_ENV || "development",
});

// 10 Seconds timeout of waiting
const timeout_doGetUser = 10000;

// Function that will wait the user state
function userGetPromise(timeout) {
  var start = Date.now();
  return new Promise(waitForUser);

  function waitForUser(resolve, reject) {
    // store exists and user state too - this is our case to go forward
    if (router.app.$store && router.app.$store.state.user)
      resolve(router.app.$store.state.user);
    // time for waiting is up
    else if (timeout && Date.now() - start >= timeout) {
      reject();
    } else {
      // wait for 30ms and look for user again
      setTimeout(waitForUser.bind(this, resolve, reject), 30);
    }
  }
}

router.beforeEach(async (to, from, next) => {
  if (["privacy", "agreement"].includes(to.name)) {
    return next();
  }
  if (to.name == "home") return next();
  if (router.history._startLocation.includes("session-by-url")) {
    next();
    return;
  }

  var user = router.app.$store.state.user;
  if (!user) {
    // Making promise, to wait until the App will get the user state
    // To check it's role

    // Otherwise returning false (forbidden 403)
    await userGetPromise(timeout_doGetUser).then(() => {
      user = router.app.$store.state.user;
    });
  }
  if (user == undefined) return false;
  if (!to.meta || !to.meta["requiredRoles"]) return next();
  if (to.meta["requiredRoles"].includes(user.role)) next();
  else router.push("noaccess");
});

export default router;
